export default function MxIDUseID() {
  try {
    return crypto.randomUUID();
  } catch (e) {
    const { v4 } = require("uuid");
    return v4();
  }
}
